/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import { Editor } from './components/Editor';
export default Editor;



//////////////////
// WEBPACK FOOTER
// ./~/@tinymce/tinymce-vue/lib/es2015/index.js
// module id = 242
// module chunks = 1